// This file is auto-generated by @hey-api/openapi-ts

export type CategorySchema = {
    id: number;
    softwareCount: number;
    allSoftwareCount: number;
    order: number;
    name: string;
    slug: string;
    /**
     * The parent category in the hierarchy.
     */
    parent_id?: number | null;
};

export type InstalledComponentsSchema = {
    filename: string;
    /**
     * The parsed version used for reliable sorting and comparison.
     */
    version: string;
};

export type SaveInstalledSoftwareRequestSchema = {
    userUuid: string;
    installedComponents: Array<InstalledComponentsSchema>;
};

export type SoftwareFilterSchema = {
    category__in?: Array<(number)>;
    category?: string;
    status?: string;
    status_not?: string;
};

export type SoftwareListSchema = {
    id: number;
    status: SoftwareStatus;
    slug: string;
    vendorSlug: string;
    name: string;
    vendor?: string;
    /**
     * The category this software belongs to.
     */
    category_id?: number | null;
    /**
     * A short description for list pages.
     */
    shortDescription?: string;
    cover?: string | null;
    /**
     * The date and time this record was created.
     */
    createdAt: string;
    /**
     * The date and time this record was last modified.
     */
    modifiedAt: string;
};

export enum SoftwareStatus {
    BLANK = 'blank',
    ENABLED = 'enabled',
    DISABLED = 'disabled',
    REJECTED = 'rejected',
    PENDING = 'pending',
    ERROR = 'error',
    VENDOR_PAYWALL = 'vendor_paywall'
}

export type SoftwareSchema = {
    id: number;
    status: SoftwareStatus;
    allowedExtensions: Array<(string)>;
    youtubeReviewsUrls: Array<(string)>;
    youtubeTutorialsUrls: Array<(string)>;
    youtubeOtherUrls: Array<(string)>;
    documentationUrls: Array<(string)>;
    slug: string;
    vendorSlug: string;
    name: string;
    vendor?: string;
    /**
     * The category this software belongs to.
     */
    category_id?: number | null;
    description?: string;
    /**
     * A short description for list pages.
     */
    shortDescription?: string;
    cover?: string | null;
    url?: string;
    /**
     * Use <b>%USER_FOLDER%</b> to refer to the user's home folder, e.g.  <b>%USER_FOLDER%/Library/Audio/Presets/MySoftware.</b><br/>Note: <b>%USER_FOLDER%</b>  doesn't contain a trailing slash.
     */
    macPresetsFolder?: string | null;
    /**
     * Use <b>%USER_FOLDER%</b> to refer to the user's home folder, e.g.  <b>%USER_FOLDER%/Library/Audio/Presets/MySoftware.</b><br/>Note: <b>%USER_FOLDER%</b>  doesn't contain a trailing slash.
     */
    macPresetsUserOwnedFolder?: string | null;
    rating?: number;
    /**
     * Internal notes and comments for the team.
     */
    internalNotes?: string;
    /**
     * The date and time this record was created.
     */
    createdAt: string;
    /**
     * The date and time this record was last modified.
     */
    modifiedAt: string;
};

export enum ArchitectureChoices {
    UNIVERSAL = 'universal',
    ARM = 'arm',
    INTEL = 'intel'
}

export enum Status {
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    FAILED = 'FAILED',
    REJECTED = 'REJECTED'
}

export type VersionSchema = {
    id: number;
    components: Array<(string)>;
    macInstallOrder: Array<(string)>;
    status: Status;
    architecture: ArchitectureChoices;
    /**
     * The software this version belongs to.
     */
    software_id: number;
    version?: string;
    platform?: string;
    type?: string;
    /**
     * File download URL, e.g. https://example.com/file.dmg
     */
    url?: string;
    /**
     * The date and time this record was created.
     */
    createdAt: string;
    /**
     * The date and time this record was last modified.
     */
    modifiedAt: string;
    /**
     * The user who created this record.
     */
    created_by_id?: number | null;
    /**
     * The user who last modified this record.
     */
    modified_by_id?: number | null;
};

export type Input = {
    limit?: number;
    offset?: number;
};

export type SoftwareFilter = {
    category?: Array<(number)>;
    status?: 'blank' | 'enabled' | 'disabled' | 'rejected' | 'pending' | 'error' | 'vendor_paywall';
    has_blank_version_urls?: boolean;
    has_pending_versions?: boolean;
};

export type AdminSoftwareListSchema = {
    id: number;
    status: SoftwareStatus;
    lastValidVersion: string;
    createdByEmail: string;
    descriptionOk: boolean;
    youtubeReviewsUrls: Array<(string)>;
    youtubeTutorialsUrls: Array<(string)>;
    documentationUrls: Array<(string)>;
    name: string;
    /**
     * The category this software belongs to.
     */
    category_id?: number | null;
    cover?: string | null;
    url?: string;
    vendor?: string;
    /**
     * The date and time this record was created.
     */
    createdAt: string;
    /**
     * The date and time this record was last modified.
     */
    modifiedAt: string;
    /**
     * Internal notes and comments for the team.
     */
    internalNotes?: string;
};

export type PagedAdminSoftwareListSchema = {
    items: Array<AdminSoftwareListSchema>;
    count: number;
};

export type SoftwareCreateSchema = {
    name: string;
};

export type AdminSoftwareUpdateSchema = {
    youtubeReviewsUrls: Array<(string)>;
    youtubeTutorialsUrls: Array<(string)>;
    youtubeOtherUrls: Array<(string)>;
    documentationUrls: Array<(string)>;
    name: string;
    /**
     * The category this software belongs to.
     */
    category_id?: number | null;
    status?: string;
    description?: string;
    url?: string;
    vendor?: string;
    /**
     * Internal notes and comments for the team.
     */
    internalNotes?: string;
};

export type AdminVersionUpdateSchema = {
    components?: Array<(string)>;
    macInstallOrder?: Array<(string)>;
    version?: string | null;
    /**
     * CPU architecture for the version (universal binary, ARM/Apple Silicon, or Intel)
     */
    architecture?: string | null;
    type?: string | null;
    /**
     * File download URL, e.g. https://example.com/file.dmg
     */
    url?: string | null;
    status?: string | null;
    /**
     * Reason why this version was rejected (e.g., vendor paywall, unavailable download).
     */
    rejectionReason?: string | null;
};

export type AdminUpdateCategorySchema = {
    order: number;
    parent_id: number | null;
    name: string;
    id?: number | null;
};

export type VersionFilter = {
    status?: 'PENDING' | 'ACTIVE' | 'FAILED' | 'REJECTED';
    versionIsBlank?: boolean;
    ids?: Array<(number)>;
};

export type CategoriesApiListResponse = Array<CategorySchema>;

export type CategoriesApiGetData = {
    id: number;
};

export type CategoriesApiGetResponse = CategorySchema;

export type InstalledSoftwareApiSaveInstalledSoftwareData = {
    requestBody: SaveInstalledSoftwareRequestSchema;
};

export type InstalledSoftwareApiSaveInstalledSoftwareResponse = string;

export type SoftwareApiListData = {
    category?: string;
    categoryIn?: Array<(number)>;
    limit?: number;
    order?: string;
    search?: string;
    status?: string;
    statusNot?: string;
};

export type SoftwareApiListResponse = Array<SoftwareListSchema>;

export type SoftwareApiGetData = {
    id: number;
};

export type SoftwareApiGetResponse = SoftwareSchema;

export type SoftwareApiGetSofwareVersionsData = {
    id: number;
};

export type SoftwareApiGetSofwareVersionsResponse = Array<VersionSchema>;

export type SoftwareApiGetLatestSofwareVersionsData = {
    id: number;
};

export type SoftwareApiGetLatestSofwareVersionsResponse = Array<VersionSchema>;

export type SoftwareAdminApiListData = {
    category?: Array<(number)>;
    hasBlankVersionUrls?: boolean;
    hasPendingVersions?: boolean;
    limit?: number;
    offset?: number;
    ordering?: string;
    query?: string;
    status?: 'blank' | 'enabled' | 'disabled' | 'rejected' | 'pending' | 'error' | 'vendor_paywall';
};

export type SoftwareAdminApiListResponse = PagedAdminSoftwareListSchema;

export type SoftwareAdminApiStatusesResponse = {
    [key: string]: unknown;
};

export type SoftwareAdminApiCreateData = {
    requestBody: SoftwareCreateSchema;
};

export type SoftwareAdminApiCreateResponse = SoftwareSchema;

export type SoftwareAdminApiUploadCoverFileData = {
    id: number;
};

export type SoftwareAdminApiUploadCoverFileResponse = {
    [key: string]: unknown;
};

export type SoftwareAdminApiUploadFileData = {
    formData: {
        file: (Blob | File);
        folder: string;
    };
};

export type SoftwareAdminApiUploadFileResponse = {
    [key: string]: unknown;
};

export type SoftwareAdminApiUpdateData = {
    id: number;
    requestBody: AdminSoftwareUpdateSchema;
};

export type SoftwareAdminApiUpdateResponse = SoftwareSchema;

export type SoftwareAdminApiCreateVersionData = {
    softwareId: number;
};

export type SoftwareAdminApiCreateVersionResponse = string;

export type SoftwareAdminApiUpdateVersionData = {
    id: number;
    requestBody: AdminVersionUpdateSchema;
};

export type SoftwareAdminApiUpdateVersionResponse = VersionSchema;

export type SoftwareAdminApiDeleteVersionData = {
    id: number;
};

export type SoftwareAdminApiDeleteVersionResponse = {
    [key: string]: unknown;
};

export type SoftwareAdminApiUpdateCategoryData = {
    requestBody: Array<AdminUpdateCategorySchema>;
};

export type SoftwareAdminApiUpdateCategoryResponse = Array<AdminUpdateCategorySchema>;

export type VersionsApiListData = {
    ids?: Array<(number)>;
    limit?: number;
    offset?: number;
    status?: 'PENDING' | 'ACTIVE' | 'FAILED' | 'REJECTED';
    versionIsBlank?: boolean;
};

export type VersionsApiListResponse = Array<VersionSchema>;

export type VersionsApiGetData = {
    id: number;
};

export type VersionsApiGetResponse = VersionSchema;

export type $OpenApiTs = {
    '/api/categories/': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: Array<CategorySchema>;
            };
        };
    };
    '/api/categories/{id}/': {
        get: {
            req: CategoriesApiGetData;
            res: {
                /**
                 * OK
                 */
                200: CategorySchema;
            };
        };
    };
    '/api/installed-software/save/': {
        post: {
            req: InstalledSoftwareApiSaveInstalledSoftwareData;
            res: {
                /**
                 * OK
                 */
                200: string;
            };
        };
    };
    '/api/software/': {
        get: {
            req: SoftwareApiListData;
            res: {
                /**
                 * OK
                 */
                200: Array<SoftwareListSchema>;
            };
        };
    };
    '/api/software/{id}/': {
        get: {
            req: SoftwareApiGetData;
            res: {
                /**
                 * OK
                 */
                200: SoftwareSchema;
            };
        };
    };
    '/api/software/{id}/versions/': {
        get: {
            req: SoftwareApiGetSofwareVersionsData;
            res: {
                /**
                 * OK
                 */
                200: Array<VersionSchema>;
            };
        };
    };
    '/api/software/{id}/latest_versions/': {
        get: {
            req: SoftwareApiGetLatestSofwareVersionsData;
            res: {
                /**
                 * OK
                 */
                200: Array<VersionSchema>;
            };
        };
    };
    '/api/software-admin/': {
        get: {
            req: SoftwareAdminApiListData;
            res: {
                /**
                 * OK
                 */
                200: PagedAdminSoftwareListSchema;
            };
        };
    };
    '/api/software-admin/statuses/': {
        get: {
            res: {
                /**
                 * OK
                 */
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/software-admin/software/': {
        post: {
            req: SoftwareAdminApiCreateData;
            res: {
                /**
                 * OK
                 */
                200: SoftwareSchema;
            };
        };
    };
    '/api/software-admin/software/{id}/upload-cover-file/': {
        post: {
            req: SoftwareAdminApiUploadCoverFileData;
            res: {
                /**
                 * OK
                 */
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/software-admin/upload-file/': {
        post: {
            req: SoftwareAdminApiUploadFileData;
            res: {
                /**
                 * OK
                 */
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/software-admin/software/{id}/': {
        put: {
            req: SoftwareAdminApiUpdateData;
            res: {
                /**
                 * OK
                 */
                200: SoftwareSchema;
            };
        };
    };
    '/api/software-admin/software/{software_id}/create_version/': {
        post: {
            req: SoftwareAdminApiCreateVersionData;
            res: {
                /**
                 * OK
                 */
                200: string;
            };
        };
    };
    '/api/software-admin/version/{id}/': {
        patch: {
            req: SoftwareAdminApiUpdateVersionData;
            res: {
                /**
                 * OK
                 */
                200: VersionSchema;
            };
        };
        delete: {
            req: SoftwareAdminApiDeleteVersionData;
            res: {
                /**
                 * OK
                 */
                200: {
                    [key: string]: unknown;
                };
            };
        };
    };
    '/api/software-admin/categories/': {
        put: {
            req: SoftwareAdminApiUpdateCategoryData;
            res: {
                /**
                 * OK
                 */
                200: Array<AdminUpdateCategorySchema>;
            };
        };
    };
    '/api/versions/': {
        get: {
            req: VersionsApiListData;
            res: {
                /**
                 * OK
                 */
                200: Array<VersionSchema>;
            };
        };
    };
    '/api/versions/{id}/': {
        get: {
            req: VersionsApiGetData;
            res: {
                /**
                 * OK
                 */
                200: VersionSchema;
            };
        };
    };
};